module.exports = __webpack_public_path__ + "static/media/boys-and-girls.5df55a07.jpg";